<template>
  <v-card dark outlined>
    <v-card-title class="secondary py-1 text-subtitle-1">
      <v-icon left dense> mdi-home </v-icon>
      Stalls
      <v-spacer />
    </v-card-title>

    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="items"
        single-select
        class="elevation-5"
        return-objects
      >
        <template v-slot:item.StallName="{ item }">
          {{ item.StallName ? item.StallName : "No data available" }}
        </template>

        <template v-slot:item.Abn="{ item }">
          {{ item.Abn ? item.Abn : "No data available" }}
        </template>

        <template v-slot:item.CardSurchargePercentage="{ item }">
          {{
            typeof item.CardSurchargePercentage === "number"
              ? item.CardSurchargePercentage
              : "0"
          }}
        </template>

        <template v-slot:item.PaymentProfile="{ item }">
          {{
            item.PaymentProfile
              ? Array.isArray(item.PaymentProfile)
                ? item.PaymentProfile.join(", ")
                : item.PaymentProfile.toString()
              : "No data available"
          }}
        </template>

        <template v-slot:item.PrintingProfile="{ item }">
          {{
            item.PrintingProfile ? item.PrintingProfile : "No data available"
          }}
        </template>

        <template v-slot:item.StandardDrinkLimit="{ item }">
          {{
            item.StandardDrinkLimit
              ? item.StandardDrinkLimit
              : "No data available"
          }}
        </template>

        <template v-slot:item.StandardDrinkLimitEnforce="{ item }">
          {{
            item.StandardDrinkLimitEnforce !== undefined
              ? item.StandardDrinkLimitEnforce
                ? "Enforce"
                : "Prompt"
              : "No data available"
          }}
        </template>

        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer />
            <v-btn x-small dark class="mb-2" @click="$emit('create')">
              <v-icon left x-small> mdi-plus </v-icon>
              Add Stall
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="$emit('edit', item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="$emit('delete', item)"> mdi-delete </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary"> No stalls for this stallholder </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StallTable",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "StallName" },
        { text: "ABN", value: "Abn" },
        { text: "Card Surcharge (%)", value: "CardSurchargePercentage" },
        { text: "Payment Profile", value: "PaymentProfile" },
        { text: "Printing Profile", value: "PrintingProfile" },
        { text: "Standard Drink Limit", value: "StandardDrinkLimit" },
        { text: "Drink Limit Profile", value: "StandardDrinkLimitEnforce" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
};
</script>
